import React, { Component } from 'react'
import { connect } from 'react-redux'
import { storage } from '../../../../config/firebaseConfig';
import Loader from 'react-loader-spinner';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import ReactModal from 'react-modal';
import ManageMemberAll from './ManageMemberAll'
import ManageMemberModal from './ManageMemberModal';
import { openCompanyDashboardModal } from '../../../../store/actions/companyActions'

class ManageMemberCard extends Component {
    constructor(props) {
        super()
        this.state = {
            memberNameForSearch: "",
            showAllManageMembersModal: false,
            showConfirmModal: false,
            toBeChangedEmployeeMapJson: null,
            changerEmployeeMapJson: null,
        }
    }

    /// README: TO BE SEARCH ENTRY
    handleSearch = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /// README: SEARCH STRING VALIDITY CHECK
    //      (return true if "" and " " is not entered as first character)
    checkValidSearch = () => {
        const { memberNameForSearch } = this.state;
        return (memberNameForSearch === "" || memberNameForSearch.startsWith(" ")) === false;
    }

    /// README: FILTERS THE accessMap BY SEARCH STRING
    filterBySearch = (s) => {
        const { memberNameForSearch } = this.state;
        var sname = `${s.name}`;
        return sname.toLowerCase().startsWith(memberNameForSearch.toLowerCase());
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num, changerEmployeeMapJson, toBeChangedEmployeeMapJson) => {
        switch (num) {
            case 0: {
                this.setState({ showAllManageMembersModal: true, showConfirmModal: false });
                break;
            }
            case 1: {
                this.setState({ showAllManageMembersModal: false, showConfirmModal: true, changerEmployeeMapJson, toBeChangedEmployeeMapJson, });
                break;
            }
            default: {
                this.setState({ showAllManageMembersModal: false, showConfirmModal: false });
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showAllManageMembersModal: false });
                break;
            }
            case 1: {
                this.setState({ showConfirmModal: false });
                break;
            }
            default: {
                this.setState({ showAllManageMembersModal: false, showConfirmModal: false });
                break;
            }
        }
    }

    /// README: RENDER THE UI
    render() {
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        // const csscard = {
        //     display: "block",
        //     width: "30vw",
        //     height: "20vw"

        // }


        const { modalWidth, modalTitleStyle, companyData, userData, alu, modalStyles, company } = this.props;
        // const { isModalCalled } = company;
        // console.log(isModalCalled)
        const { allMembers, coid, accessMap } = companyData;
        const { uid, employeeid } = userData;
        var ueid = uid + employeeid;
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var accessName = accessMap ? ueid in accessMap ? accessMap[ueid]['name'] : alu.invalid : alu.invalid;
        var employeeMapJson = accessMap ? ueid in accessMap ? accessMap[ueid] : null : null;

        return (
            <div className="card p-2" style={{ borderRadius: '15px' }} key={coid}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-12">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Manage members</p>
                        </div>

                        {/* <div className="col-2">
                            <MDICONS.AddCircleOutlineRounded />
                        </div> */}
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-group text-left">
                        <input type="text" className="form-control" id="memberNameForSearch" placeholder="Search for a member" onChange={this.handleSearch} />
                        <div>
                            {'accessMap' in companyData ? Object.keys(companyData.accessMap).length !== 0 ? this.checkValidSearch() ? Object.values(companyData.accessMap).filter(this.filterBySearch).slice(0, 2).map((val, i) => {
                                var mueid = val.uid + val.employeeid;
                                var memberAccessLevel = accessMap ? mueid in accessMap ? accessMap[mueid]['access'] : alu.invalid : alu.invalid;
                                return (
                                    <div key={i}>
                                        <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                                            <div className="d-flex" >
                                                <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                                                    <br />
                                                    <p className="badge badge-pill  px-3" style={{ backgroundColor: `${alu.color[memberAccessLevel]}`, color: `${alu.textColor[memberAccessLevel]}`, textAlign: "start", fontSize: "10px", fontStyle: "italic" }}>
                                                        {alu.text[memberAccessLevel]}</p>
                                                </div>
                                                <div className="p-2 flex-fill">
                                                    <div className="btn btn-outline-dark btn-sm float-right" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(1, employeeMapJson, val); this.props.openCompanyDashboardModal() }}>Settings</div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                )
                            }) : '' : 'No member found' : 'No member found'}
                        </div>
                        <br />

                        <div className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} onClick={() => { this.handleOpenModal(0) }}>View all</div>

                    </div>
                </div>

                {/* MANAGE MEMBER MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showAllManageMembersModal}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Manage all members"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <ManageMemberAll memberNameForSearch={this.state.memberNameForSearch} />
                </ReactModal>

                {/* CONFIRM MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showConfirmModal}
                    onRequestClose={() => { this.handleCloseModal(1) }}
                    contentLabel="Manage member"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <ManageMemberModal toBeChangedEmployeeMapJson={this.state.toBeChangedEmployeeMapJson} changerEmployeeMapJson={this.state.changerEmployeeMapJson} />
                </ReactModal>
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        company: state.company,
        formLabelStyle: state.appControl.formLabelStyle,
        floor: state.floor,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        modalStyles: state.appControl.modalStyles,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openCompanyDashboardModal: () => dispatch(openCompanyDashboardModal()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ManageMemberCard)


